import { SagaIterator } from "redux-saga";
import { approveRepaymentInstrumentBulkRequestApi, createRepaymentInstrumentBulkRequestApi, fetchRepaymentInstrumentBulkRequestApi, fetchRepaymentInstrumentBulkRequestAuaditApi, fetchRepaymentInstrumentBulkRequestDetailApi, fetchRepaymentInstrumentBulkRequestsSettledEntriesApi, fetchRepaymentInstrumentBulkRequestsSettledEntriesDetailApi, fetchRepaymentInstrumentBulkRequestVersionApi, rejectRepaymentInstrumentBulkRequestApi, reviewRepaymentInstrumentBulkRequestApi } from "./api";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { CreateRepaymentBulkIntrument, FetchRepaymentIntrumentBulkRequest, FetchSingleRepaymentIntrumentBulkRequestInfo, RepaymentInstrumentBulkRequestType, reviewBulkRepayment } from "./types";

function* createRepaymentInstrumentBulkRequest({ payload, type }: CreateRepaymentBulkIntrument): SagaIterator {
  try {
    const response = yield call(createRepaymentInstrumentBulkRequestApi, payload)
    yield put({
      type: RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchRepaymentInstrumentBulkRequest({ payload, type }: FetchRepaymentIntrumentBulkRequest): SagaIterator {
  try {
    const response = yield call(fetchRepaymentInstrumentBulkRequestApi, payload);
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchRepaymentInstrumentBulkRequestDetail({ payload, type }: FetchSingleRepaymentIntrumentBulkRequestInfo): SagaIterator {
  try {
    const response = yield call(fetchRepaymentInstrumentBulkRequestDetailApi, payload);
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchRepaymentInstrumentBulkRequestVersion({ payload, type }: FetchSingleRepaymentIntrumentBulkRequestInfo): SagaIterator {
  try {
    const response = yield call(fetchRepaymentInstrumentBulkRequestVersionApi, payload);

    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchRepaymentInstrumentBulkRequestFilters({ payload, type }: FetchRepaymentIntrumentBulkRequest): SagaIterator {
  try {
    const response = yield call(fetchRepaymentInstrumentBulkRequestApi, payload);
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS_ERROR,
      payload: { error: error }
    });
  }
}

function* approveRepaymentInstrumentBulkRequest({ payload, type }: any): SagaIterator {
  try {
    const response = yield call(approveRepaymentInstrumentBulkRequestApi, payload);

    yield put({
      type: RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR,
      payload: { error: error }
    });
  }
}

function* rejectRepaymentInstrumentBulkRequest({ payload, type }: any): SagaIterator {
  try {
    const response = yield call(rejectRepaymentInstrumentBulkRequestApi, payload);

    yield put({
      type: RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchRepaymentInstrumentBulkRequestSettledEntries({ payload, type }: any): SagaIterator {
  try {
    const response = yield call(fetchRepaymentInstrumentBulkRequestsSettledEntriesApi, payload);
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchRepaymentInstrumentBulkRequestSettledEntriesDetail({ payload, type }: FetchSingleRepaymentIntrumentBulkRequestInfo): SagaIterator {
  try {
    const response = yield call(fetchRepaymentInstrumentBulkRequestsSettledEntriesDetailApi, payload);
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL_ERROR,
      payload: { error: error }
    });
  }
}

function* reviewRepaymentInstrumentBulkRequest({ payload, type }: any): SagaIterator {
  try {
    const response = yield call(reviewRepaymentInstrumentBulkRequestApi, payload);
    yield put({
      type: RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST_ERROR,
      payload: { error: error }
    });
  }
}

function* bulkRepaymentInstrumentRequestAudit({ payload, type }: any): SagaIterator {
  try {
    const response = yield call(fetchRepaymentInstrumentBulkRequestAuaditApi, payload);
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT_ERROR,
      payload: { error: error }
    });
  }
}

export function* watchCreateRepaymentInstrumentBulkRequest() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.CREATE_REPAYMENT_INSTRUMENT_BULK_REQUEST, createRepaymentInstrumentBulkRequest);
}

export function* watchFetchRepaymentInstrumentBulkRequest() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST, fetchRepaymentInstrumentBulkRequest);
}

export function* watchFetchRepaymentInstrumentBulkRequestDetail() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_DETAIL, fetchRepaymentInstrumentBulkRequestDetail);
}

export function* watchFetchRepaymentInstrumentBulkRequestVersion() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_VERSION, fetchRepaymentInstrumentBulkRequestVersion);
}

export function* watchFetchRepaymentInstrumentBulkRequestFilters() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_FILTERS, fetchRepaymentInstrumentBulkRequestFilters);
}

export function* watchAppoveRepaymentInstrumentBulkRequest() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.APPROVE_REPAYMENT_INSTRUMENT_BULK_REQUEST, approveRepaymentInstrumentBulkRequest);
}

export function* watchRejectRepaymentInstrumentBulkRequest() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.REJECT_REPAYMENT_INSTRUMENT_BULK_REQUEST, rejectRepaymentInstrumentBulkRequest);
}

export function* watchFetchRepaymentInstrumentBulkRequestSettledEntries() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES, fetchRepaymentInstrumentBulkRequestSettledEntries);
}

export function* watchFetchRepaymentInstrumentBulkRequestSettledEntriesDetail() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_SETTLED_ENTRIES_DETAIL, fetchRepaymentInstrumentBulkRequestSettledEntriesDetail);
}

export function* watchReviewRepaymentInstrumentBulkRequest() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.REVIEW_REPAYMENT_INSTRUMENT_BULK_REQUEST, reviewRepaymentInstrumentBulkRequest);
}

export function* watchFetchBulkRepaymentInstrumentAudit() {
  yield takeEvery(RepaymentInstrumentBulkRequestType.FETCH_REPAYMENT_INSTRUMENT_BULK_REQUEST_AUDIT, bulkRepaymentInstrumentRequestAudit);
}


function* RepaymentBulkInstrumentSaga() {
  yield all([
    fork(watchCreateRepaymentInstrumentBulkRequest),
    fork(watchFetchRepaymentInstrumentBulkRequest),
    fork(watchFetchRepaymentInstrumentBulkRequestFilters),
    fork(watchFetchRepaymentInstrumentBulkRequestDetail),
    fork(watchAppoveRepaymentInstrumentBulkRequest),
    fork(watchRejectRepaymentInstrumentBulkRequest),
    fork(watchFetchRepaymentInstrumentBulkRequestVersion),
    fork(watchFetchRepaymentInstrumentBulkRequestSettledEntries),
    fork(watchFetchRepaymentInstrumentBulkRequestSettledEntriesDetail),
    fork(watchReviewRepaymentInstrumentBulkRequest),
    fork(watchFetchBulkRepaymentInstrumentAudit)
  ]);
}

export default RepaymentBulkInstrumentSaga;